import {Component, Input} from "@angular/core";

import {DisplayableOrderItem} from "../order";

/**
 * Display the details of extras for an order item
 */
@Component({
    selector: "woa-order-extras-panel",
    templateUrl: "order-extras-panel.component.html"
})
export class OrderExtrasPanelComponent {
    @Input() item: DisplayableOrderItem;
    @Input() showTotal: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/order/order-extras-panel/order-extras-panel.component.ts